/* globals document */
import React from 'react';
import displayName from 'component-lib/displayName';

/**
 * PanelManager injects a number of props into the component that it decorates:
 *
 * onCloseAll(func): give it a function to execute when the document is clicked
 */
export default function PanelManager(component) {
    return class PanelManagerComponent extends React.Component {
        static displayName = displayName('CompositeComponents/DropdownPanel/PanelManager');

        constructor(props) {
            super(props);

            this.container = null;
            this.buttons = {};
            this.panels = {};
        }

        componentDidMount() {
            document.addEventListener('click', this.onCloseAll);
        }

        componentWillUnmount() {
            document.removeEventListener('click', this.onCloseAll);
        }

        onCloseAll = (e) => {
            // don't try to close it if the target has gone away
            if (!$(e.target).length) { return; }

            const dontClose = Object.keys(this.panels).reduce(
                (exit, panelName) => ['panels', 'buttons'].reduce((innerExit, sourceName) => {
                    if (innerExit) { return true; }

                    const panelComponent = this[sourceName][panelName];

                    if (!panelComponent || !panelComponent.DOMNode) { return false; }

                    return panelComponent.DOMNode.contains(e.target);
                }, exit)
                , false
            );

            if (dontClose) { return; }

            this.registeredOnCloseAll();
        };

        positionPanels = () => {
            if (!this.container) { return; }

            Object.keys(this.panels).forEach((panelName) => {
                if (this.panels[panelName] && this.buttons[panelName]) {
                    const DOMPanel = this.panels[panelName].DOMNode;
                    const DOMButton = this.buttons[panelName].DOMNode;

                    if (!DOMButton) {
                        console.warn(`${this.buttons[panelName]}.displayName} needs to implement DOMNode!`);
                    }

                    if (!DOMPanel || !DOMPanel.style) { return; }

                    DOMPanel.style.left =
            `${(DOMButton.offsetLeft + DOMButton.offsetWidth) - DOMPanel.offsetWidth}px`;

                    // ...then show the panel once it's positioned.
                    DOMPanel.style.opacity = 1;
                }
            });
        };

        render() {
            return React.createElement(
                component,
                {
                    ...this.props,
                    onCloseAll: (func) => {
                        this.registeredOnCloseAll = func;
                    },
                    refHandlers: {
                        container: (container) => {
                            this.container = container;
                            this.positionPanels();
                        },
                        button: which => (button) => {
                            this.buttons[which] = button;
                            this.positionPanels();
                        },
                        panel: which => (panel) => {
                            this.panels[which] = panel;
                            this.positionPanels();
                        },
                    },
                },
            );
        }
    };
}
